import React, { FC, ReactNode } from "react";
import classNames, { Argument } from "classnames/dedupe";

export interface IMainHeaderProps {
  isGender?: boolean;
  children?: ReactNode;
}

export const MainHeader: FC<IMainHeaderProps> = (props) => {
  const { isGender, children } = props;
  return (
    <div
      className={classNames("header-main", {
        "header-main--gender": isGender,
      })}
    >
      {children}
    </div>
  );
};

export type THeaderNavVariant =
  | "list"
  | "search"
  | "searchExtended"
  | "searchFocused"
  | "icons";

export interface IHeaderNavSectionProps {
  variant?: THeaderNavVariant;
  classes?: {
    root: Argument;
  };
  children?: ReactNode;
}

const headerNavClassMapping: Record<THeaderNavVariant, string> = {
  list: "header-nav--list",
  search: "header-search flex-grow-collapse",
  searchExtended: "header-search header-search--extended",
  searchFocused: "header-search flex-grow-1",
  icons: "header-nav--icons",
};

export const HeaderNavSection: FC<IHeaderNavSectionProps> = ({
  variant,
  classes,
  children,
}) => (
  <div
    className={classNames(
      "header-nav",
      headerNavClassMapping[variant],
      classes?.root,
    )}
  >
    {children}
  </div>
);

type TMainHeaderVariant = "center" | "bottom";
export interface IMainHeaderContainerProps {
  /**
   * The layout location style Header component
   *
   * @type {('center'|'bottom')}
   */
  variant: TMainHeaderVariant;
  paddedLogo?: boolean;
  children?: ReactNode;
}

export const MainHeaderContainer: FC<IMainHeaderContainerProps> = ({
  variant,
  paddedLogo,
  children,
}) => {
  const rootClasses = classNames({
    "header-center": variant === "center",
    "header-bottom": variant === "bottom",
    "header-center--padded-logo": variant === "center" && paddedLogo,
  });

  return <div className={rootClasses}>{children}</div>;
};
